import { DEFAULT_HEADER_COLOR, WHITE_1, TRANSPARENT } from '../constants/colors.constants';

export const HEADER_STYLE = {
  FULL: 'full',
  BASIC: 'basic',
  BOOKING_DATA: 'basic booking-data',
  HOTEL_RESULTS_TRANSPARENT: 'hotel-results-transparent',
  AUTO_RESULTS: 'auto-results',
  SPECIAL: 'special',
  HOME_TRANSPARENT: 'home-transparent'
};

export interface Header {
  classType: string;
  showOptions: boolean;
  title: string;
  color: string;
  showTitle: boolean;
  previewColor: string;
}

export const INITIAL_HEADER: Header = {
  classType: HEADER_STYLE.FULL,
  showOptions: true,
  title: null,
  color: DEFAULT_HEADER_COLOR,
  showTitle: false,
  previewColor: DEFAULT_HEADER_COLOR
};

export const HEADER_STYLES: Header[] = [
  {
    classType: HEADER_STYLE.FULL,
    showOptions: true,
    title: null,
    color: DEFAULT_HEADER_COLOR,
    showTitle: false,
    previewColor: DEFAULT_HEADER_COLOR
  },
  {
    classType: HEADER_STYLE.BASIC,
    showOptions: true,
    title: null,
    color: DEFAULT_HEADER_COLOR,
    showTitle: false,
    previewColor: DEFAULT_HEADER_COLOR
  },
  {
    classType: HEADER_STYLE.BOOKING_DATA,
    showOptions: true,
    title: null,
    color: DEFAULT_HEADER_COLOR,
    showTitle: false,
    previewColor: DEFAULT_HEADER_COLOR
  },
  {
    classType: HEADER_STYLE.HOTEL_RESULTS_TRANSPARENT,
    showOptions: true,
    title: null,
    color: TRANSPARENT,
    showTitle: false,
    previewColor: TRANSPARENT
  },
  {
    classType: HEADER_STYLE.SPECIAL,
    showOptions: true,
    title: null,
    color: DEFAULT_HEADER_COLOR,
    showTitle: false,
    previewColor: DEFAULT_HEADER_COLOR
  },
  {
    classType: HEADER_STYLE.HOME_TRANSPARENT,
    showOptions: true,
    title: null,
    color: TRANSPARENT,
    showTitle: false,
    previewColor: TRANSPARENT
  },
  {
    classType: HEADER_STYLE.AUTO_RESULTS,
    showOptions: true,
    title: null,
    color: WHITE_1,
    showTitle: false,
    previewColor: WHITE_1
  },
];
